/**
 * "Does a Connect need to prompt for a password first?" predicate.
 *
 * Shared by the general on-connect password prompt (Workstream B2). A prompt
 * is needed only when the auth type requires a password AND none is available
 * (neither a transient plaintext nor a keychain-stored one). Windows auth,
 * every Microsoft Entra variant, and "No password" NEVER prompt.
 */
import type { Connection } from '../../../types/electron';

export function connectionNeedsPasswordPrompt(connection: Connection | null | undefined): boolean {
  if (!connection) return false;
  // A password is already available — nothing to ask for.
  if (connection.password) return false;
  if (connection.hasStoredPassword) return false;

  const engine = connection.engine ?? 'mssql';
  if (engine === 'sqlite') return false;

  const auth = connection.authentication;
  if (engine === 'mssql') {
    return auth === 'SQL Server authentication';
  }
  // pgsql / mysql / oracle (and other password-based engines) use 'Password'.
  return auth === 'Password';
}
